<template>
  <div class="py2">
    <div class="col-12 p0 my1 break-word">
      <h2 class="m0 caps">
        DOCUMENTS JUSTIFICATIFS
      </h2>
    </div>

    <div class="relative no-box">
      <!-- User Documents Card -->
      <div class="col-12 my3 white-bg lg-contact-card border-bottom">
        <DocumentsUserHeader :current-participant="currentParticipant" />
        <DocumentsUpload :current-participant="currentParticipant" />
      </div>

      <div class="flex justify-end">
        <Button class="col-4 sm-col-12 ml2" text="Precedent" :color="'grey-bg'" :action="() => changeToPage('Tariffs')" />
        <Button class="col-4 sm-col-12 ml2" text="Suivant" :action="handleOptionFlow" />
      </div>
    </div>
  </div>
</template>

<script>
import DocumentsUserHeader from '../../components/documents/DocumentsUserHeader';
import DocumentsUpload from '../../components/documents/DocumentsUpload';
import Button from '../../components/elements/Button';

import { changeToPage, handleOptionFlow } from '@/utils/logics';

export default {
  components: {
    DocumentsUserHeader,
    DocumentsUpload,
    Button
  },
  data () {
    return { currentParticipant: this.$store.state.currentParticipant };
  },
  methods: {
    changeToPage,
    handleOptionFlow
  }
};
</script>

<style lang="scss" scoped>

</style>
